import React from 'react';

export const Switch = ({extraClasses, value, handler, ...props}) => {
    return (
        <label class={`switch ${extraClasses}`}>
            <input type="checkbox" checked={value} onChange={handler} />
            <span class="slider round"></span>
        </label>
    );
};



// WEBPACK FOOTER //
// ./src/customModules/Common/form/Switch.js